<template>
	
	<div>
		<div>
			<Button type="primary" icon="ios-search" @click="searchByConditionsView">搜索</Button>
		</div>
		<Modal title="Title" v-model="modal9" :mask-closable="false" width="800">
        <p slot="header" style="color:#0066FF;text-align:center">
          <Icon type="md-create" />
          <span>{{"设备编号: " +this.mac}}</span>
        </p>
        <div style="text-align:left">
          <Table
            width="762"
            size="large"
            border
            stripe
            :loading="loading"
            :columns="columns2"
            :data="data2"
          ></Table>
          <br />
        </div>
        <div slot="footer"></div>
      </Modal>

		<Modal title="Title" v-model="searchModal" :mask-closable="false" width="380">
			<p slot="header" style="color:#0066FF;text-align:center">
				<span>搜索</span>
			</p>
			<div style="padding-left: 20px;">
				<CheckboxGroup v-model="selectedConditions" class="check_group">
					<div>
						<Checkbox label="num">
							<span>设备编号</span>
						</Checkbox>
						<Input v-model="condition.num" placeholder="" />
					</div>
				</CheckboxGroup>
			</div>
			<div slot="footer">
				<Button type="info" size="large" long @click="searchByCondition">立即搜索</Button>
			</div>
		</Modal>

		<br />
		<Table size="large" border stripe :loading="loading" :columns="columns1" :data="data1">
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" shape="circle" icon="ios-apps" @click="modelClick(row, index)"></Button>
			</template>
		</Table>
		<br />

		<Page :current="currentPage" :total="totalRows" :page-size="pageSize" :page-size-opts="[5, 10, 20, 30, 40, 50]"
			show-sizer show-total @on-change="changePage" @on-page-size-change="changePageSize" />
	</div>
</template>

<script>
	import {
		constants
	} from "crypto";
	export default {
		name: "meter_work_info",
		
		data() {
			let that = this;
			return {
				boxProfile: {},
				data1: [],
				data2: [],
				modal9 : false,
				loading: true,
				coefficient:"",
				mac:"",
				showDrawer: false,
				selectDataHtml: '',
				selectData: {},
				searchModal: false,
				currentPage: 1,
				pageSize: 30,
				totalRows: 0,
				selectedConditions: [],
				condition: {
					id: '',
					mac: '',
					subType: '',
					happenTimeRange: [],
				},
				requestBody: {},
				columns2: [
					{
						title: "日期",
						sortable: true,
						align: "center",
						render: function(h, params) {
							return h("div", params.row.happenTime);
						}
					},
					{
						title: "日用气量",
						align: "center",
						render: function(h, params) {
							let data = JSON.parse(params.row.content);
							return h("div",
							((data['cycleNum']*params.row.coefficient)/1000).toFixed(4) +" m³"
							);
						}
					}
				],
				columns1: [
					{
						title: "姓名",
						key: "name",
						align: "center",
					},
					{
						title: "电话",
						key: "telephone",
						align: "center",
					},
					{
						title: "地址",
						key: "address",
						align: "center",
        			},
					{
						title: "设备编号",
						key: "num",
						align: "center",
					},
					{
						title: "操作",
						slot: "action",
						align: "center",
						width: 100

					}
				],
			};
		},
		created() {
			this.getMessage()
		},
		mounted() {

		},
		methods: {
			searchByConditionsView() {
				this.searchModal = true;
			},
			modelClick(row, index){
				this.getOperationData(row, index);
				this.mac=row.num;
				this.coefficient = row.coefficient;
			},
			getOperationData(row, index){
				var that = this;
				that.requestBody["mac"] =row.mac;
				that.requestBody["subType"] ="dayUpload",
				this.modal9 =true;
				$.ajax({
					url: "/api/alarm/admin/buildingmessage/getUploadList",
					type: "post",
					data: that.requestBody,
					success: function(res) {
						if (res.code == 0) {
							that.data2 = res.data.list;
							that.modal9 = true;
						} else {
							that.$Notice.error({
							title: "异常",
							desc: res.errorInfo
							});
						}
					},
					error: function(textStatus) {
					that.loading = false;
					that.$Notice.error({
						title: "异常",
						desc: "接口请求异常"
					});
					},
					complete: function() {
					that.loading = false;
					}
				});
			},
			dateFtt(fmt, date) {
				return global.dateFtt(fmt, new Date(date));
			},
			// 显示条件检索页面
			showSearch() {
				this.searchModal = true;
			},
			searchByCondition() {
				this.requestBody = {};
				for (let i in this.selectedConditions) {
					let selectedCondition = this.selectedConditions[i]
					switch (selectedCondition) {
						case 'happenTime':
							let happenTimeBegin = this.condition.happenTimeRange[0];
							if (happenTimeBegin != '') {
								this.requestBody['happenTimeBegin'] = global.dateFtt('yyyy-MM-dd hh:mm:ss',
									happenTimeBegin);
							}
							let happenTimeEnd = this.condition.happenTimeRange[1];
							if (happenTimeEnd != '') {
								this.requestBody['happenTimeEnd'] = global.dateFtt('yyyy-MM-dd hh:mm:ss', happenTimeEnd);
							}
							if (this.num != "") {
								this.requestBody["num"] = this.num;
							}
							break;
						default:
							let value = this.condition[selectedCondition];
							if (value == null || value == '') {
								break;
							}

							this.requestBody[selectedCondition] = value;
							break;
					}
				}

				this.loading = true;
				this.searchModal = false;
				this.currentPage = 1;
				this.getMessage1();
			},
			getMessage1() {
				let that = this;
				if (localStorage.getItem("isAdmin") != "true") {
				that.requestBody["companyNum"] = localStorage.getItem("personnelGroverningBodyId");
    			}
				$.ajax({
					url: "/api/alarm/admin/buildingmessage/getAlarmBuildingDayUploadList?currentPage=" +
						that.currentPage +
						"&pageSize=" +
						that.pageSize,
					type: "post",
					data: that.requestBody,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}
						that.data1 = result.data.list;
						that.totalRows = result.data.totalRows;
						that.loading = false;
					},
					error: function(textStatus) {
						that.loading = false;
						that.$Notice.error({
							title: "异常",
							desc: "网络不通"
						});
					}
				});
			},
			getMessage() {
				let that = this;
				if (localStorage.getItem("isAdmin") != "true") {
				that.requestBody["companyNum"] = localStorage.getItem("personnelGroverningBodyId");
    			}
				$.ajax({
					url: "/api/alarm/admin/buildingmessage/getAlarmBuildingDayUploadList?currentPage=" +
						that.currentPage +
						"&pageSize=" +
						that.pageSize,
					type: "post",
					data: that.requestBody,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}
						that.data1 = result.data.list;
						that.totalRows = result.data.totalRows;
						that.loading = false;
					},
					error: function(textStatus) {
						that.loading = false;
						that.$Notice.error({
							title: "异常",
							desc: "网络不通"
						});
					}
				});
			},
			changePageSize(pageSize) {
				this.pageSize = pageSize;
				this.request();
			},
			changePage(index) {
				this.currentPage = index;
				this.loading = true;
				this.getMessage();
			},
			convertData(data, type, enums) {
				let result = data;
				if (type == "Time") {
					result = global.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(data * 1000));
				} else if (type == "Enum") {
					result = enums[data] == null ? data : enums[data];
				}
				return result;
			}
		},
	};
</script>

<style>
	.check_group>div {
		margin-bottom: 10px;
	}

	.check_group>div>label {
		width: 100px;
	}

	.check_group>div>div {
		width: 200px;
	}

	.ivu-date-picker {
		width: 100%;
	}
</style>
